// @flow
import type { FilterIconDefinition } from '~/core/constants/actions';

import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { Container, DiscoverIcon, IconCell, IconContainer, IconText } from './styles';

type iconProps<T> = {
    definition: FilterIconDefinition<T>,
    onClick: () => void,
    selected: boolean
};
const Icon = <T>({ definition, onClick, selected }: iconProps<T>) => (
    <IconCell canBeUsed={definition.canBeUsed || definition.isUniversal} onClick={onClick} selected={selected}>
        <IconContainer selected={selected}>
            <DiscoverIcon type={definition.icon} />
        </IconContainer>
        <IconText>
            <FormattedMessage {...definition.text} />
        </IconText>
    </IconCell>
);

type Props<T> = {
    changeFilter: (selectedItem: T) => void,
    list: Array<FilterIconDefinition<T>>,
    selectedItem?: T
};
export default <T>({ changeFilter, list, selectedItem }: Props<T>) => {
    return (
        <Container>
            {list.map(
                (item, index) =>
                    !item.hidden && (
                        <Icon
                            definition={item}
                            key={`icon-${index}`}
                            onClick={() => changeFilter(item.id)}
                            selected={selectedItem === item.id}
                        />
                    )
            )}
        </Container>
    );
};



// WEBPACK FOOTER //
// ./src/components/widgets/actions/filter/icons-list/component.js